<div
  class="relative w-full h-full flex flex-row gap-1 lg:gap-2 rounded-full bg-white/60 dark:bg-black/60 px-2 lg:px-4 py-1"
>
  @for (toolType of toolTypeList; track toolType.name) {
    @if (userData != null || toolType.name != 'Preset') {
      @if (toolType.name != 'AI' || project()?.title == 'BMW M2 G87 2023') {
        <div class="relative flex flex-col justify-center items-center group">
          <button
            class="relative w-6 h-6 lg:w-10 lg:h-10 rounded-full p-0.5 lg:p-1.5 disabled:opacity-40 opacity-100"
            [disabled]="
              isLoading() ||
              (project()?.title == 'Servus Japan SF19' &&
                toolType.name != 'Livery' &&
                userData?.email != 'info@scattre.co' &&
                userData?.email != 'ldu0009@gmail.com')
            "
            [ngClass]="{
              'bg-white dark:bg-black': toolType == selectedTool(),
              'dark:group-hover:bg-black/60 group-hover:bg-white/60':
                project()?.title != 'Servus Japan SF19' ||
                toolType.name == 'Livery' ||
                userData?.email == 'info@scattre.co' ||
                userData?.email == 'ldu0009@gmail.com',
              'dark:group-hover:bg-none group-hover:bg-none':
                project()?.title == 'Servus Japan SF19' &&
                toolType.name != 'Livery' &&
                userData?.email != 'info@scattre.co' &&
                userData?.email != 'ldu0009@gmail.com',
            }"
            (click)="onClickTool(toolType)"
          >
            <div
              class="relative w-full h-full text-black dark:text-white rounded-full group-hover:scale-110 group-active:scale-90 transition-transform duration-150 ease-in-out"
              [ngClass]="{
                'opacity-100': toolType == selectedTool(),
                'opacity-60': toolType != selectedTool(),
                'opacity-40 group-hover:scale-100 group-active:scale-100':
                  project()?.title == 'Servus Japan SF19' &&
                  toolType.name != 'Livery' &&
                  userData?.email != 'info@scattre.co' &&
                  userData?.email != 'ldu0009@gmail.com',
              }"
              [innerHTML]="toolType.icon | safeHtml"
            ></div>
          </button>
          @if (!isNameHide()) {
            <p
              class="text-[10px] lg:text-xs text-black dark:text-white font-semibold opacity-60 group-hover:opacity-80"
              [ngClass]="{
                'opacity-100': toolType == selectedTool(),
                'opacity-30 group-hover:opacity-30':
                  project()?.title == 'Servus Japan SF19' &&
                  toolType.name != 'Livery' &&
                  userData?.email != 'info@scattre.co' &&
                  userData?.email != 'ldu0009@gmail.com',
                'opacity-60': toolType != selectedTool(),
              }"
            >
              {{ toolType.name }}
            </p>
          }
        </div>
      }
    }
  }
</div>
